import { MoonstarCreate } from '../Moonstar/MoonstarCreate';
import { MoonstarCreateForm } from '../Moonstar/MoonstarCreateForm';
import { JourneyInputs } from './JourneyInputs';

export const JourneysCreate = () => {
  return (
    <MoonstarCreate redirect="list">
      <MoonstarCreateForm className="max-w-none">
        <JourneyInputs />
      </MoonstarCreateForm>
    </MoonstarCreate>
  );
};
